import { Injectable } from '@angular/core';
import { ConfigService } from '../common/services/config.service';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { SessionHandlerService } from '../common/services/sessionHandler.service';

@Injectable({
    providedIn: 'root'
})
export class ProductReviewService {

    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandlerService: SessionHandlerService,
    ) { }

    public GetCallService(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.getSummaryDetails;
        url = url.replace('{applicationId}', data.applicationId);
        url = url.replace('{quoteId}', data.quoteId);
        return this._httpInterceptor.Get(url);
    }

    public GetPolicy(data) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.getPolicy;
        url = url.replace('{applicationId}', data.urlData.applicationId);
        url = url.replace('{quoteId}', data.urlData.quoteId);
        return this._httpInterceptor.Post(url, data.payload);
    }

    //for loading mock json (to be removed later)
    public getMockService() {
        return this._httpInterceptor.Get('assets/MockJson/GetSummaryMock.json');
    }
    public PostCallRenewal(data) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.postProductReview;
        return this._httpInterceptor.Post(url, data.payload);
    }

    public postSendMobileOTP(data) {
        data.notificationTypeCode = 'IMHLTHMOBILEOTP';
        const url = ConfigService.getInstance().getConfigObject().APIURL.resumeGetOtp;
        return this._httpInterceptor.Post(url, data);
    }
    public postValidateOTP(data) {
        const url = ConfigService.getInstance().getConfigObject().APIURL.ValidatePostOtp;
        return this._httpInterceptor.Post(url, data);
    }
    public postSendMobileOTPForReviewDetails(payload) {
        const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
        let url = ConfigService.getInstance().getConfigObject().APIURL.postOTPForReviewDetail;
        url = url.replace('{quoteId}', quoteId);
        url = url.replace('{applicationId}', applicationId);

        return this._httpInterceptor.Post(url, payload);
    }
    public postValidateOTPForReviewDetails(data) {
        const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
        let url = ConfigService.getInstance().getConfigObject().APIURL.ValidatePostOtpForReviewDetails;
        url = url.replace('{quoteId}', quoteId);
        url = url.replace('{applicationId}', applicationId);

        return this._httpInterceptor.Put(url, data);
    }
    public postResendSendMobileOTPForReviewDetails(payload, consentKey) {
        const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
        const quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
        let url = ConfigService.getInstance().getConfigObject().APIURL.resendOtpForReviewDetail;
        url = url.replace('{quoteKey}', quoteId);
        url = url.replace('{applicationId}', applicationId);
        url = url.replace('{consentkey}', consentKey);
        return this._httpInterceptor.Put(url, payload);
    }

    public postSendQuotationLinkService(payload) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.sendQuotatioLinkService;
        return this._httpInterceptor.Post(url, payload);
    }

    public GetProposerDetails(quoteId: string, applicationId: any) {
        let url = ConfigService.getInstance()
            .getConfigObject().APIURL.getProposerDetails;
        url = url.replace('{applicationId}', applicationId ? applicationId : 0);
        url = url.replace('{quoteId}', quoteId ? quoteId : 0);
        url = url.replace('{health}', 'HEALTHCLP');
        return this._httpInterceptor.Get(url, true);
    }
}
